module.exports = __webpack_public_path__ + "static/media/mage_circle.d67db038.svg";